import searchOrderReducer from './searchOrder.slice';

const { combineReducers } = require('@reduxjs/toolkit');

const paymentSearchReducer = combineReducers({
  searchOrder: searchOrderReducer,
});

export default paymentSearchReducer;
